define('modules/base/models/token.model',[
        'underscore',
        'backbone',
    'modules/base/models/base.model'
    ], function (_, Backbone, BaseModel) {
    var TokenModel = BaseModel.extend({
        base: 'auth',
        fetch: function(options) {
            options = options ? _.clone(options) : {};
            if (options.parse === void 0) options.parse = true;
            var model = this;
            var success = options.success;

            options.success = function(resp, status, xhr) {
                if (!model.set(model.parse(resp, options), options)) return false;
                if (success) success(model, resp, options);
                model.trigger('sync', model, resp, options);
            };
            //wrapError(this, options);
            return this.sync('read', this, options);
        }
    });
    return TokenModel;
});


